var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnpinned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.99967L9.66667 10.6663H7.66667V13.333L7 15.333L6.33333 13.333V10.6663H3V8.66634L5 6.66634V5.99967ZM10.3333 1.33301V2.66634L9 3.33301V6.66634L11 8.66634V10.307L7.18 6.48634L5 4.30634V3.33301L3.66667 2.66634V1.33301H10.3333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.514635 1.51367L-0.332031 2.36034L12.6413 15.3337L13.488 14.487L6.33464 7.33367L0.514635 1.51367Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnpinned);
export default __webpack_public_path__ + "static/media/unpinned.b19fd1fae5f9f8b4adaf410f58152b44.svg";
export { ForwardRef as ReactComponent };